// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminAssetsShare = {
  share: {
    title: "Asset Sharing",
    notice:
      "Sharing governance is independent from asset metadata editing and follows the formal shared-resource model directly.",
    publicDescription: "Public assets grant view, reference, and clone by default.",
    selectedUsersTitle: "Selected Users",
    emptyUsers: "No users selected",
    actions: {
      pickUsers: "Pick Users",
    },
    fields: {
      capabilities: "Capabilities",
    },
    capabilities: {
      view: "View",
      reference: "Reference",
      clone: "Clone",
    },
    errors: {
      requiredShareMode: "Please select a share mode",
      selectAtLeastOneUser: "Please select at least one user",
      selectCapabilities: "Please select at least one capability",
    },
    messages: {
      saveSuccess: "Asset sharing saved",
      saveFailed: "Failed to save asset sharing",
    },
  },
} as const;
